import React from "react";
import { MDBFooter, MDBContainer } from "mdb-react-ui-kit";
import fb from "../../assets/fb.svg";
import twitter from "../../assets/Twitter.svg";
import google from "../../assets/Google.svg";
import utube from "../../assets/Youtube.svg";
import email from "../../assets/email.svg";
import phone from "../../assets/phone.svg";
import "./styles.css";
import routeNames from "../../routes/routeNames";

export default function App() {
  return (
    <MDBFooter
      className="text-center text-white"
      style={{ backgroundColor: "#f1f1f1" }}
    >
      <MDBContainer className="pt-4">
        <section className="d-flex justify-content-center gap-5 mobb">
          <p>
            <a
              href={routeNames.general.aboutUs}
              className="text-dark text-decoration-none"
            >
              About Us
            </a>
          </p>
          <p>
            <a href={routeNames.general.faqs} className="text-dark text-decoration-none">
              FAQs
            </a>
          </p>
          <p>
            <a
              href={routeNames.general.terms}
              className="text-dark text-decoration-none"
            >
              Terms Of Use
            </a>
          </p>
          <p>
            <a
              href={routeNames.general.privacy}
              className="text-dark text-decoration-none"
            >
              Privacy Policy
            </a>
          </p>
          <p>
            <a
              href={routeNames.general.contactus}
              className="text-dark text-decoration-none"
            >
              Contact Us
            </a>
          </p>
        </section>
        <section className="pb-3 d-flex text-black flex-column gap-1">
          <a className="d-flex align-items-center justify-content-center gap-2 text-decoration-none text-dark">
            <img src={phone} width="16px" /> 866-500-7171
          </a>
          <a className="d-flex align-items-center justify-content-center gap-2 text-decoration-none text-dark">
            <img src={email} /> support@faces2hire.com
          </a>
        </section>
        <section className="pb-4 d-flex justify-content-center gap-5">
          <a href="https://www.facebook.com/faces2hire">
            <img src={fb} width="30px" />
          </a>
          <a href="https://twitter.com/faces2hire">
            <img src={twitter} width="30px" />
          </a>
          <a>
            <img src={google} width="30px" />
          </a>
          <a href="https://www.youtube.com/faces2hire">
            <img src={utube} width="30px" />
          </a>
        </section>
      </MDBContainer>
    </MDBFooter>
  );
}
